import get from 'lodash/get';

import getErrorObject from '../../../utils/validations/getErrorObject';
import { ERROR_CODES } from '../../../constants/errors';

export default (error, formatMessage, fieldName = 'emailOrPhone') => {
  const code = get(error, 'code');
  if (!code) return null;

  if (code === ERROR_CODES.LOGIN_NOT_FOUND)
    return getErrorObject(
      fieldName,
      'invalid',
      formatMessage({
        id:
          fieldName === 'username'
            ? 'errors.login.unauthorized'
            : 'errors.login.notFound',
      }),
    );

  if (code === ERROR_CODES.REGISTRATION_NOT_FINISHED)
    return getErrorObject(
      fieldName,
      'invalid',
      formatMessage({ id: 'errors.login.registrationNotFinished' }),
    );

  if (code === ERROR_CODES.INVALID_LOGIN)
    return getErrorObject(
      fieldName,
      'invalid',
      formatMessage({ id: 'errors.login.incorrect' }),
    );

  return getErrorObject(
    fieldName,
    'invalid',
    formatMessage({ id: 'errors.common' }),
  );
};



// WEBPACK FOOTER //
// ./src/components/Auth/utils/transformErrors.js